import { GATEWAY_ROUTE_VISION_IP } from '@/core/const/gatewayRoutes.const'
import { fetchOr } from '@/core/utils/fetch'

import { buildUrl, type GatewayConfig } from './libraries.api'

export const fetchGatewayIp = async (config: GatewayConfig): Promise<string> => {
  const url = `${buildUrl(config)}/${GATEWAY_ROUTE_VISION_IP}`
  return (await fetchOr(url, '')).trim()
}
